import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PuffLoader } from 'react-spinners';
import printJS from 'print-js';
import { get, isEmpty } from 'lodash';
import Button from '../../components/Button';
import Header from '../../components/Header';
import Download from '../../assets/images/icon-download.svg';
import Print from '../../assets/images/icon-print.svg';
import {
  getDocument,
  newCheckInAction,
  NEW_CHECKIN,
} from '../../actions/navigation';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';
import PdfViewer from '../esign-loan-documents/PdfViewer';
import './style.scss';

const SignLoanDocument = (props) => {
  const [salesReceiptDocument, setSalesReceiptDocument] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const match = useParams();

  const { checkinData } = props;

  const generateDocument = () => {
    const apiUrl = get(checkinData, 'data.data.salesReceiptDocumentUrl');
    props.getDocument({
      url: apiUrl,
      success: async (response) => {
        setSalesReceiptDocument(`data:application/pdf;base64,${response}`);
        setIsLoading(false);
      },
      fail: (error) => {
        console.log('Error', error);
        setIsLoading(false);
      },
    });
  };

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (isEmpty(checkinData)) {
      const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
      props.newCheckInAction({
        workflowType,
        key: params.key,
      });
    }

    if (!isEmpty(checkinData) && (props.fetch.isDone[`${NEW_CHECKIN}`] && !props.fetch.isRunning[`${NEW_CHECKIN}`]) && !get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))) {
      if (!get(checkinData, 'data.url', '').startsWith('/luwa/application/signloandocument') && !get(checkinData, 'data.url', '').startsWith('/dtm-luwa-dponly/application/signloandocument') && !get(checkinData, 'data.url', '').startsWith('/dtm-luwa-dponly-ric/application/signloandocument')) {
        let routeUrl = get(checkinData, 'data.url');
        if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
          routeUrl = addLusaHeaderParam(routeUrl);
        }
        props.navigate(routeUrl);
      } else {
        generateDocument();
      }
    }
  }, [checkinData]);

  const handleDownloadDocument = (e) => {
    e.preventDefault();
    const downloadLink = document.createElement('a');
    downloadLink.href = salesReceiptDocument;
    downloadLink.download = 'Sales_Receipt.pdf';
    downloadLink.click();
  };

  const handlePrintDocument = (e) => {
    e.preventDefault();
    printJS({
      printable: salesReceiptDocument.replace('data:application/pdf;base64,', ''),
      type: 'pdf',
      base64: true,
    });
  };

  return (
    <div className="transition-item wrapper">
      <Header />
      <div className="sign-loan content text-center d-flex justify-content-center">
        {!salesReceiptDocument && <PuffLoader color="#3989E3" size={100} />}
        <div className={salesReceiptDocument ? 'd-inline-block' : 'd-none'} style={{ width: '100%' }}>
          <div className="d-flex align-middle justify-content-end">
            <div className="d-flex btn-group">
              <Button className="icon-btn" onClick={handleDownloadDocument}>
                <img src={Download} alt="Download" />
              </Button>
              <Button className="icon-btn" onClick={handlePrintDocument}>
                <img src={Print} alt="Print" />
              </Button>
            </div>
          </div>
          <div>
            {isLoading && <PuffLoader color="#3989E3" size={100} />}
            <PdfViewer file={salesReceiptDocument} />
          </div>
        </div>
      </div>
    </div>
  );
};

SignLoanDocument.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  getDocument: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  getDocument,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignLoanDocument);
